import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { MODAL_TYPES } from '../../../common/constants'
import { hideModal } from '../../../store/modal'
import { resetTableCheckbox } from '../../../store/table'
import { clearDeleteCallback, getDeleteCallback } from './utils'

interface DeleteModalProps {
    isOpen: boolean
    deleteModal: {
        callbackId: string
        appModule?: string
    }
}

const DeleteModal = (props: DeleteModalProps) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const { isOpen, deleteModal } = props
    const { appModule, callbackId } = deleteModal

    const moduleKey = appModule ? t(`modal.delete.moduleName.${appModule}`) : null

    const handleDelete = () => {
        getDeleteCallback(callbackId)?.()
        clearDeleteCallback(callbackId)

        dispatch(resetTableCheckbox(true))
        dispatch(hideModal({ modalType: MODAL_TYPES.DELETE_MODAL }))
    }

    const handleClose = () => {
        dispatch(hideModal({ modalType: MODAL_TYPES.DELETE_MODAL }))
        dispatch(resetTableCheckbox(true))
    }

    return (
        <Modal isOpen={isOpen} centered data-testid="delete-modal">
            <ModalHeader toggle={handleClose}>
                {appModule ? t('modal.delete.message.view', { moduleKey }) : t('modal.delete.message.list')}
            </ModalHeader>
            <ModalBody className="py-3 px-5">
                <div className="d-flex gap-2 justify-content-end mt-4 mb-2">
                    <Button type="button" color="primary" className="btn-label" data-bs-dismiss="modal" onClick={handleClose}>
                        <i className="mdi mdi-close label-icon align-middle fs-16"></i>
                        {t('button.cancel')}
                    </Button>
                    <Button type="button" color="danger" className="btn-label" id="delete-record" onClick={handleDelete}>
                        <i className="mdi mdi-trash-can-outline label-icon align-middle fs-16"></i>
                        {t('button.delete')}
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default DeleteModal
